import React, { useEffect, useState, useRef } from 'react';
import moment from "moment";
import redirectURL from "../redirectURL";
import './CommercialsTable.css';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker'
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {  getHyphenDDMMMYYYYHHMM } from '../common/utils';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";




const BASE_COST = 125000;
const BASE_FREE_FTL = 500; // Free FTL Trips per month
const BASE_FREE_PTL = 20000; //Free PTL Trips per month
const EXTRA_FTL_COST = 50;
const EXTRA_PTL_COST = 4;
const SIM_RATE = 12;
const CT_Resource = 30000;

export default function CommercialsTable() {
    const [freeFtlLimit, setFreeFtlLimit] = useState(BASE_FREE_FTL);
    const [freePtlLimit, setFreePtlLimit] = useState(BASE_FREE_PTL);
    const [monthlyBaseCost, setMonthlyBaseCost] = useState(BASE_COST);
    const [ctResourceCost, setCtResourceCost] = useState(CT_Resource);
    const [ftlTrips, setFtlTrips] = useState(0);
    const [ptlTrips, setPtlTrips] = useState(0);
    const [simTrips, setSimTrips] = useState(0);
    const [simTrackingDays, setSimTrackingDays] = useState(0);
    const [simTrackingCost, setSimTrackingCost] = useState(0);
    const [startDate, setStartDate] = useState(new Date(moment.parseZone().subtract(1, "month")));
    const [endDate, setEndDate] = useState(new Date(moment.parseZone().subtract(1, "month")));
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    const [loadshow, setLoadShow] = useState("show-n")
    const [overly, setOverlay] = useState("show-n");
    const [resetTrigger, setResetTrigger] = useState(0);
    const [showGrid, setShowGrid] = useState(false);
    const [activeGridTab, setActiveGridTab] = useState("ftl");
    const [ftlTripsData, setFtlTripsData] = useState([]);
    const [ptlTripsData, setPtlTripsData] = useState([]);
    const [simTripsData, setSimTripsData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    var statusMap={
        0: "At Source",
        1:"Dispatched from Source",
        2: "In Transit",
        3: "Arrived At Destination",
        4: "Out For Delivery",
        5: "Delivered",
        6: "Force Closure",
        7: "Provision",
        8: "Delivered",
        9: "Cancelled",
        10: "Trip Created",
        11: "Undelivered"
    }
    
    const reportRef = useRef();

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const fetchTripsData = async () => {
        if (!startDate || !endDate) return;
        const startMoment = moment(startDate).startOf('month');
        const endMoment = moment(endDate).endOf('month');
        const totalMonths = Math.ceil(endMoment.diff(startMoment, 'months', true));
        setFreeFtlLimit(BASE_FREE_FTL * totalMonths);
        setFreePtlLimit(BASE_FREE_PTL * totalMonths);
        setMonthlyBaseCost(BASE_COST * totalMonths);
        setCtResourceCost(CT_Resource * totalMonths);
        const params = {
            startDate: moment(startDate).startOf('month').format("YYYY-MM-DD"),
            endDate: moment(endDate).endOf('month').format("YYYY-MM-DD")
        };
        try {
            const response = await redirectURL.post('consignments/getBillingTripsCount', params);
            const data = response.data;
            setLoadShow("show-n");
            setFtlTrips(data.simTrips);
            setPtlTrips(data.ptlTrips);
            setSimTrips(data.simTrips);
            setFtlTripsData(data.simTripsData);
            setPtlTripsData(data.ptlTripsData);
            // setSimTripsData(data.simTripsData);
            // const filteredSimData = data.simTripsData.filter((trip) => {
            //     const dispatchDate = new Date(trip.dispatch_date);

            //     let deliveryDate = trip.actual_delivery_date ? new Date(trip.actual_delivery_date) : trip.recent_dealer_reported_modified ? new Date(trip.recent_dealer_reported_modified) :
            //         trip.delivery_datetime ? new Date(trip.delivery_datetime) : trip.recent_dealer_reported ? new Date(trip.recent_dealer_reported) : null;

            //     return (
            //         deliveryDate &&
            //         !isNaN(dispatchDate) &&
            //         !isNaN(deliveryDate)
            //     );
            // });

            setSimTripsData(data.simTripsData);



            // Calculate SIM Tracking Days and Cost
            // let totalDays = 0;
            // if (data.simTripsData && Array.isArray(data.simTripsData)) {
            //     data.simTripsData.forEach(trip => {
            //         const dispatchDate = new Date(trip.dispatch_date);
            //         const deliveryDate = new Date(
            //             trip.actual_delivery_date ||
            //             trip.recent_dealer_reported_modified ||
            //             trip.delivery_datetime ||
            //             new Date()
            //         );

            //         const days = Math.ceil((deliveryDate - dispatchDate) / (1000 * 60 * 60 * 24));
            //         totalDays += Math.max(days, 1);

            //     });
            // }

            let totalDays = 0;
            let validSimTripCount = 0;

            if (data.simTripsData && Array.isArray(data.simTripsData)) {
                data.simTripsData.forEach(trip => {
                    const dispatchDate = new Date(trip.created_date);
                    let deliveryDate = null;
                    if (trip.actual_delivery_date) {
                        deliveryDate = new Date(trip.actual_delivery_date);
                    } else if (trip.recent_dealer_reported_modified) {
                        deliveryDate = new Date(trip.recent_dealer_reported_modified);
                    } else if (trip.delivery_datetime) {
                        deliveryDate = new Date(trip.delivery_datetime);
                    }
                    else if (trip.recent_dealer_reported) {
                        deliveryDate = new Date(trip.recent_dealer_reported);
                    }
                    if (deliveryDate && !isNaN(dispatchDate) && !isNaN(deliveryDate)) {
                        const days = Math.ceil((deliveryDate - dispatchDate) / (1000 * 60 * 60 * 24));
                        totalDays += Math.max(days, 1);
                        validSimTripCount += 1;
                    }
                });
            }

            setSimTrips(data.simTrips);
            setSimTrackingDays(totalDays);
            setSimTrackingCost(totalDays * SIM_RATE);
        } catch (error) {
            console.error("Failed to fetch trip data:", error);
            setFtlTrips(0);
            setPtlTrips(0);
            setSimTrips(0);
            setSimTrackingDays(0);
            setSimTrackingCost(0);
            setLoadShow("show-n");
        } finally {
            setLoadShow("show-n");
        }
    };
    const exportExcel = () => {
        if (!gridApi) {
            console.log("Grid API not ready");
            return;
        }

        let fileName = "Trips.xlsx";
        if (activeGridTab === "ftl") fileName = "FTL_Trips.xlsx";
        else if (activeGridTab === "ptl") fileName = "PTL_Trips.xlsx";
        else if (activeGridTab === "sim") fileName = "SIM_Trips.xlsx";
        else if (activeGridTab === "all") fileName = "ALL_Trips.xlsx";

        gridApi.exportDataAsExcel({
            fileName: fileName
        });
    };
    const downloadPDF = async () => {
        const input = reportRef.current;

        if (!input) return;

        const canvas = await html2canvas(input, {
            scale: 2,            // Higher scale = sharper PDF
            useCORS: true,
            allowTaint: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("Billing_Report.pdf");
    };


    const onConfirm = () => {
        setShow(false);
        setLoadShow("show-n");
    };

    const handleStartDateChange = (date) => {
        if (endDate && moment(date).isAfter(endDate, 'month')) {
            setShow(true);
            setTitle("From Date should be less than To Date");
            setType("danger");
        } else {
            setStartDate(date);
        }
    };

    const handleEndDateChange = (date) => {
        if (startDate && moment(date).isBefore(startDate, 'month')) {
            setShow(true);
            setTitle("To Date should be greater than From Date");
            setType("danger");
        } else {
            setEndDate(date);
        }
    };

    const handleSumbit = async (event) => {
        event.preventDefault();
        setLoadShow("show-m");
        await fetchTripsData();
    };

    const resetFilters = async () => {
        //Initially setting 1 month
        const today = new Date(moment.parseZone().subtract(1, "month"));
        setStartDate(new Date(moment.parseZone().subtract(1, "month")));
        setEndDate(today);
        setFreeFtlLimit(BASE_FREE_FTL);
        setFreePtlLimit(BASE_FREE_PTL);
        setMonthlyBaseCost(BASE_COST);
        setCtResourceCost(CT_Resource);
        setLoadShow("show-m");
        setResetTrigger(prev => prev + 1); // triggers fetch in useEffect
    };

    // Auto-call when dates change
    useEffect(() => {
        setLoadShow("show-m");
        fetchTripsData();
    }, [resetTrigger]);

    const extraFtlTrips = Math.max(ftlTrips - freeFtlLimit, 0);
    const extraPtlTrips = Math.max(ptlTrips - freePtlLimit, 0);
    const extraFtlCost = extraFtlTrips * EXTRA_FTL_COST;
    const extraPtlCost = extraPtlTrips * EXTRA_PTL_COST;
    const totalCost = monthlyBaseCost + extraFtlCost + extraPtlCost + simTrackingCost + ctResourceCost;
    const fixedColumns = [
        {
            headerName: "Tracking Mode",
            field: "tracking_type",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "LR No",
            field: "lr_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Invoice No",
            field: "invoice_list",
            width: 150,
            resizable: true,
            headerClass: 'bold-header',
        },
        {
            headerName: "Vehicle No",
            field: "truck_no",
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Status",
            field: "status",
            valueGetter: (params) => {
                const consignmentStatus = params.data?.consignment_status;
                const status = params.data?.status;

                return consignmentStatus || statusMap[status] || status || "Not Available";
            },
        },
        {
            headerName: "Invoice Date",
            field: "invoice_time",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                if (params.data.invoice_time != '' && params.data.invoice_time != undefined && params.data.invoice_time !== ' ') {
                    return getHyphenDDMMMYYYYHHMM(params.data.invoice_time);
                }
                else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Dispatch Date",
            field: "dispatch_date",
            width: 150,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const dispatchDate = params.data.dispatch_date;
                if (dispatchDate && dispatchDate.trim() !== '' && dispatchDate !== undefined) {
                    const formattedDate = getHyphenDDMMMYYYYHHMM(dispatchDate);
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "LR Updated Date",
            field: "created_date",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const createdDate = params.data.created_date;
                if (createdDate && createdDate.trim() !== '' && createdDate !== undefined) {
                    const formattedDate = getHyphenDDMMMYYYYHHMM(createdDate);
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Entity",
            field: "truck_seal_entity",
           
            width: 150,
            cellRenderer: '', resizable: true,
            valueGetter: function (params) {
                if (params.data.truck_seal_entity != "" && params.data.truck_seal_entity != undefined) {
                    return capitalizeWords(params.data.truck_seal_entity)
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Transporter",
            field: "transporter_name",
           
            width: 180,
            filter: "agSetColumnFilter",
            cellRenderer: '',
            resizable: true,
            valueGetter: function (params) {
                if (params.data.transporter_name != "" && params.data.transporter_name != undefined) {
                    return (params.data.transporter_name ? capitalizeWords(params.data.transporter_name) : "")
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Source City",
            field: "consigner_city",
           
            width: 150,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consigner_city != "" && params.data.consigner_city != undefined) {
                    return capitalizeWords(params.data.consigner_city)
                }
            },
        },
        {
            headerName: "Source Pincode",
            field: "consigner_pincode",
            
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination Pincode",
            field: "consignee_pincode",
           
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
        {
            headerName: "Destination State",
            field: "consignee_state",
           
            width: 180,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter: function (params) {
                if (params.data.consignee_state != "" && params.data.consignee_state != undefined) {
                    return capitalizeWords(params.data.consignee_state)
                }
            },
        },
         {
            headerName: "Transporter Category" ,
            field: "tpt_category",
            colId: "tpt_category",
            width: 190,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header'
        },
         {
            headerName: "SIM Consent Status" ,
            field: "sim_consent_status",
            colId: "sim_consent_status",
            // hide: (tabName.value === "inactive"),
            width: 200,
            cellRenderer: '', resizable: true,
            headerClass: 'bold-header',
            valueGetter:(params)=>{
                if(params.data.tracking_type ==="PTL"){
                   return ""
               }else if(params.data.tracking_type ==="FTL" &&( params.data.sim_issue===0)){
                   return "Consent Approved"
               }else if(params.data.tracking_type ==="FTL" && params.data.sim_issue>0 ){
                   return "Consent Pending"
               }else if(params.data.sim_issue===null || params.data.sim_issue===undefined){
               return ""
               }
           }
        },
        {
            headerName: "Actual Delivery Date",
            field: "actual_delivery_date",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const value = params.data.actual_delivery_date;
                if (value && value.trim() !== '' && value !== undefined) {
                    const formattedDate = getHyphenDDMMMYYYYHHMM(value);
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Recent Dealer Reported Modified",
            field: "recent_dealer_reported_modified",
            width: 220,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const value = params.data.recent_dealer_reported_modified;
                if (value && value.trim() !== '' && value !== undefined) {
                    const formattedDate = getHyphenDDMMMYYYYHHMM(value);
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Delivery Date Time",
            field: "delivery_datetime",
            width: 180,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const value = params.data.delivery_datetime;
                if (value && value.trim() !== '' && value !== undefined) {
                    const formattedDate = getHyphenDDMMMYYYYHHMM(value);
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Recent Dealer Reported",
            field: "recent_dealer_reported",
            width: 200,
            cellRenderer: '', resizable: true,
            comparator: dateComparator,
            valueGetter: function (params) {
                const value = params.data.recent_dealer_reported;
                if (value && value.trim() !== '' && value !== undefined) {
                    const formattedDate = getHyphenDDMMMYYYYHHMM(value);
                    return formattedDate !== "Invalid Date" ? formattedDate : "NA";
                } else {
                    return "NA";
                }
            },
            headerClass: 'bold-header'
        },
        {
            headerName: "Sim Transit Days",
            field: "transit_days",
            width: 160,
            resizable: true,
            headerClass: "bold-header",
            valueGetter: (params) => {
                const row = params.data;

                // show only SIM tracking rows
                if (!(row.tracking_type === "FTL" && row.sim_issue === 0)) {
                    return "";
                }

                const startDate = row.created_date ? new Date(row.created_date) : null;

                const endDate =
                    row.actual_delivery_date ? new Date(row.actual_delivery_date) :
                        row.recent_dealer_reported_modified ? new Date(row.recent_dealer_reported_modified) :
                            row.delivery_datetime ? new Date(row.delivery_datetime) :
                                row.recent_dealer_reported ? new Date(row.recent_dealer_reported) :
                                    null;

                if (!startDate || !endDate || isNaN(startDate) || isNaN(endDate)) {
                    return "";
                }

                const days = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));

                return Math.max(days, 1);
            }
        }
    ];

    return (
        <div className='main-container'>
            <SweetAlert
                show={show}
                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                onConfirm={onConfirm}
                customClass='sweetWidth'
                type={type}>
            </SweetAlert>
            <div className="invoice-filter-wrapper">
                <div className="invoice-filter-grid"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        gap: "20px"
                    }}
                >
                    <div className="filter-group">
                        <label className="filter-label">From Date</label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            onKeyDown={(e) => e.preventDefault()}
                            className="filter-datepicker"
                        />
                    </div>
                    <div className="filter-group">
                        <label className="filter-label">To Date</label>
                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            onKeyDown={(e) => e.preventDefault()}
                            className="filter-datepicker"
                            minDate={startDate}
                        />
                    </div>
                    <div style={{ display: "flex", gap: "10px", marginTop:"23px" }}>
                        <button
                            className="filter-btn primary"
                            onClick={handleSumbit}
                            disabled={!startDate || !endDate}
                        >
                            Submit
                        </button>
                        <button
                            className="filter-btn secondary"
                            onClick={resetFilters}
                        >
                            Reset
                        </button>
                    </div>
                    <button
                        className="filter-btn secondary"
                        onClick={() => setShowGrid(true)}
                        style={{
                            marginLeft: "auto",
                            marginTop: "23px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"  
                        }}
                        title="View Data"
                    >
                        <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>

                        <span>View Data</span>
                    </button>


                    <button
                        className="filter-btn secondary"
                        onClick={downloadPDF}
                        style={{ marginTop: "23px" }}
                        title="Download Billing Report PDF"
                    >
                        ⭳ Billing Report PDF
                    </button>
                </div>
            </div>
            <div className="commercials-container" ref={reportRef}>
                <h5 className="mb-3">Billing Report</h5>
                <table className="commercials-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Particulars</th>
                            <th>Final Costing</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td><strong>Track and Trace</strong></td>
                            <td><strong>₹{monthlyBaseCost.toLocaleString('en-IN')}</strong></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <div className="scope-wrapper">
                                    <p><strong>Scope</strong></p>
                                    <table className="inner-scope-table">
                                        <thead>
                                            <tr>
                                                <th>Tracking Mode</th>
                                                <th>Total Trips</th>
                                                <th>Free Limit</th>
                                                <th>Extra Used</th>
                                                <th>Rate / Trip</th>
                                                <th>Extra Cost</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>FTL</td>
                                                <td>{ftlTrips}</td>
                                                <td>{freeFtlLimit}</td>
                                                <td>{extraFtlTrips}</td>
                                                <td>₹{EXTRA_FTL_COST}</td>
                                                <td>₹{extraFtlCost.toLocaleString('en-IN')}</td>
                                            </tr>
                                            <tr>
                                                <td>PTL</td>
                                                <td>{ptlTrips}</td>
                                                <td>{freePtlLimit}</td>
                                                <td>{extraPtlTrips}</td>
                                                <td>₹{EXTRA_PTL_COST}</td>
                                                <td>₹{extraPtlCost.toLocaleString('en-IN')}</td>
                                            </tr>
                                            <tr className="total-row">
                                                <td colSpan="5" style={{ textAlign: "right", fontWeight: "bold" }}>Total FTL and PTL Cost</td>
                                                <td style={{ fontWeight: "bold" }}>₹{(extraFtlCost + extraPtlCost).toLocaleString('en-IN')}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p className="mt-4"></p>
                                    <table className="inner-scope-table">
                                        <thead>
                                            <tr>
                                                <th>Tracking Mode</th>
                                                <th>SIM Trips</th>
                                                <th>Total Days Used</th>
                                                <th>Rate / Day</th>
                                                <th>Total SIM Cost</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>FTL</td>
                                                <td>{simTrips}</td>
                                                <td>{simTrackingDays}</td>
                                                <td>₹{SIM_RATE}</td>
                                                <td>₹{simTrackingCost.toLocaleString('en-IN')}</td>
                                            </tr>
                                            <tr className="total-row">
                                                <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>Total SIM Trips Cost</td>
                                                <td style={{ fontWeight: "bold" }}>₹{(simTrackingCost).toLocaleString('en-IN')}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </td>
                            <td className="final-extra-cost-cell">
                                <div>
                                    <strong>₹{(extraFtlCost + extraPtlCost + simTrackingCost).toLocaleString('en-IN')}</strong>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td><strong>CT Resource</strong></td>
                            <td><strong>₹{ctResourceCost.toLocaleString('en-IN')}</strong></td>
                        </tr>
                        <tr className="overall-cost-row">
                            <td colSpan="2" className="text-end fw-bold"><strong>Overall Cost</strong></td>
                            <td className="fw-bold text-success"><strong>₹{totalCost.toLocaleString('en-IN')}</strong></td>
                        </tr>


                    </tbody>
                </table>
            </div>
            {showGrid && (
                <div className="grid-overlay">
                    <div className="grid-modal">

                        <div className="grid-modal-header">
                            <h4>Trips Detailed Data</h4>
                            <button
                                className="close-btn"
                                onClick={() => setShowGrid(false)}
                            >
                                Hide Data ✕
                            </button>
                        </div>

                        <div className="trip-tabs">
                            <button
                                className={activeGridTab === "ftl" ? "active-tab" : "tab"}
                                onClick={() => setActiveGridTab("ftl")}
                            >
                                FTL Trips
                            </button>

                            <button
                                className={activeGridTab === "ptl" ? "active-tab" : "tab"}
                                onClick={() => setActiveGridTab("ptl")}
                            >
                                PTL Trips
                            </button>

                            {/* <button
                                className={activeGridTab === "sim" ? "active-tab" : "tab"}
                                onClick={() => setActiveGridTab("sim")}
                            >
                                SIM Trips
                            </button> */}

                            <button
                                className={activeGridTab === "all" ? "active-tab" : "tab"}
                                onClick={() => setActiveGridTab("all")}
                            >
                                ALL Trips
                            </button>
                        </div>

                        <div style={{ textAlign: "right", marginBottom: "12px" }}>
                            <button className="excel-btn" onClick={exportExcel}>
                                ⭳ Export Excel
                            </button>

                        </div>
                        <div className="ag-theme-balham" style={{ height: 450, width: "100%", overflow: "auto" }}>
                            <AgGridReact
                                onGridReady={onGridReady}
                                rowData={(() => {
                                    if (activeGridTab === "ftl") return ftlTripsData || [];
                                    if (activeGridTab === "ptl") return ptlTripsData || [];
                                    // if (activeGridTab === "sim") return simTripsData || [];
                                    if (activeGridTab === "all")
                                        return [
                                            ...ftlTripsData.map(r => ({ ...r, trip_type: "FTL" })),
                                            ...ptlTripsData.map(r => ({ ...r, trip_type: "PTL" })),
                                            // ...simTripsData.map(r => ({ ...r, trip_type: "SIM" })),
                                        ];
                                })()}
                                columnDefs={fixedColumns}
                                defaultColDef={{
                                    flex: 1,
                                    minWidth: 150,
                                    sortable: true,
                                    filter: true, 
                                    resizable: true,
                                }}
                                statusBar={{
                                    statusPanels: [
                                        {
                                            statusPanel: "agTotalAndFilteredRowCountComponent",
                                            align: "left"
                                        }
                                    ]
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className={"overlay-part " + (overly)} style={{ zIndex: "10" }}></div>
            <div className={"dataLoadpage " + (loadshow)}></div>
            <div className={"dataLoadpageimg " + (loadshow)} style={{ top: "21em" }}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>

        </div>
    );
}
function capitalizeWords(str) {
    if (typeof str !== 'string') return str;
    return str
        .toLowerCase()  
        .split(' ') 
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
        .join(' '); 
}
function dateComparator(date1, date2) {
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}
function monthToComparableNumber(date) {
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}